// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox--eUP7Z","checked":"checked--biRqP"};